import { INLINE_EDIT_FIELD_TEST_ID } from '@e2e/constants/exam-management';
import {
  type IconButtonProps,
  CheckIcon,
  CloseIcon,
  Flex,
  IconButton,
  styled,
} from '@shared/components';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  borderRadius: theme.spacing(1),
  border: '1px solid',
  borderColor: theme.palette.grey[300],
  backgroundColor: theme.palette.common.white,
  padding: theme.spacing(0),
}));

interface ActionButtonGroupProps {
  onDiscard: IconButtonProps['onClick'];
  onConfirm: IconButtonProps['onClick'];
}

export default function ActionButtonGroup(props: Readonly<ActionButtonGroupProps>) {
  const { onDiscard, onConfirm } = props;

  return (
    <Flex
      sx={(theme) => ({
        gap: theme.spacing(1),
        color: theme.palette.text.primary,
      })}
    >
      <StyledIconButton size='small' onClick={onConfirm}>
        <CheckIcon
          data-testid={INLINE_EDIT_FIELD_TEST_ID.CONFIRM_BUTTON}
          sx={{
            width: '18px',
            height: '18px',
          }}
        />
      </StyledIconButton>
      <StyledIconButton size='small' onClick={onDiscard}>
        <CloseIcon
          sx={{
            width: '18px',
            height: '18px',
          }}
        />
      </StyledIconButton>
    </Flex>
  );
}
